export const freshChatConfig = {
	key: '4c6f4bd8-4092-452e-834b-7b65b68c9ad1',
	// The Freshchat account is shared with Echo Vision, whose admin shows only
	// categories tagged `echovision`. Show only Nimbly platform categories here.
	// A category with no `nimbly` tag is hidden from this widget.
	faqTags: {
		tags: ['nimbly'],
		filterType: 'category',
	},
};
